import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const CheckoutModal = ({
  show,
  onHide,
  checkoutGroup,
  checkoutQuantity,
  setCheckoutQuantity,
  confirmCheckout,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Checkout Items</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>
              How many do you want to check out? (Max:{" "}
              {checkoutGroup?.quantity || 1})
            </Form.Label>

            <Form.Control
              type="number"
              min={1}
              max={checkoutGroup?.quantity || 1}
              value={checkoutQuantity}
              onChange={(e) =>
                setCheckoutQuantity(
                  Math.max(
                    1,
                    Math.min(
                      checkoutGroup?.quantity || 1,
                      Number(e.target.value)
                    )
                  )
                )
              }
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button variant="primary" onClick={confirmCheckout}>
          Checkout
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CheckoutModal;